import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import TaskList from './components/TaskList';
import Subjects from './components/Subjects';
import AddSubject from './components/AddSubject';
import AddTask from './components/AddTask';
import History from './components/History';
import BottomNav from './components/BottomNav';
import { initializeNotifications } from './utils/notifications';
import './App.css';

function App() {
  useEffect(() => {
    initializeNotifications();
  }, []);

  return (
    <ThemeProvider>
      <Router>
        <header className="app-header">
          <img src="/snlogonobg.png" alt="StudySnap Logo" className="logo" />
          <h1 className="app-title">StudySnap</h1>
        </header>
        <div className="App">
          <Routes>
            <Route path="/" element={<TaskList period="daily" />} />
            <Route path="/weekly" element={<TaskList period="weekly" />} />
            <Route path="/subjects" element={<Subjects />} />
            <Route path="/add-subject" element={<AddSubject />} />
            <Route path="/add-task" element={<AddTask />} />
            <Route path="/history" element={<History />} />
          </Routes>
          <BottomNav />
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
